import { useQuery } from "@tanstack/react-query";

import { axiosClient } from "../../utils/axiosClient";

export function getProducts(queryParameters = {}) {
    return axiosClient.get(route("products.index", queryParameters));
}

export function getProductsQueryOptions({
    queryKey = [],
    queryParameters = {},
    onSuccess = () => {},
    ...options
}) {
    return {
        queryKey: [...queryKey, queryParameters],
        queryFn: async () => {
            const response = await getProducts(queryParameters);
            onSuccess(response.data);
            return response.data;
        },
        ...options,
    };
}

export function useProductsQuery({
    queryKey = [],
    queryParameters = {},
    onSuccess = () => {},
    ...options
}) {
    return useQuery({
        ...getProductsQueryOptions({
            queryKey,
            queryParameters,
            onSuccess,
            ...options,
        }),
    });
}
